import { useQuery } from '@tanstack/react-query';
import { CLUserApi } from 'api/CL/CLUserApi';
import { useLoadingStore } from 'store/useLoadingStore';
import { useLoginStore } from 'store/useLoginDataStore';

export const useGetFavoriteUserListQueries = (sortField: string, sortOrder: string, enabled = true) => {
    const { loginData } = useLoginStore();
    const { setLoading } = useLoadingStore();

    return useQuery({
        queryKey: ['getFavoriteUserListQueries', sortField, sortOrder, loginData.hospitalId],
        queryFn: async () => {
            try {
                setLoading(true);
                const response = await CLUserApi.getFavoriteUserList(process.env.REACT_APP_CL_ADMIN_KEY!, loginData.hospitalId, sortField, sortOrder);
                if (response.status === 'ok') return response.data;
                return response.data;
            } catch (error) {
                const errorMessage = error instanceof Error ? error.message : '알 수 없는 오류가 발생했습니다';
                throw new Error(errorMessage);
            } finally {
                setLoading(false);
            }
        },
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: enabled && !!loginData.hospitalId && !!process.env.REACT_APP_CL_ADMIN_KEY,
    });
};
